// Front-end page hrefs for the audio card's title/author/liked-collection links. Ported from
// audio-web `shared/navigation/helpers`; the frontend router keys on ScreenId, so these are literal
// paths. Links to not-yet-migrated screens fall through the router to a hard navigation.

import { getUrl } from '@muse-web/url'

export const getAudioPageUrl = ({
    authorUsername,
    audioSlug,
}: {
    authorUsername: string
    audioSlug: string
}): string => `/${authorUsername}/audio/${audioSlug}`

/**
 * `from` is where the form returns on save/cancel. Passed only when set — `{ from: undefined }`
 * would leave a trailing `?`.
 */
export const getAudioEditPageUrl = ({
    authorUsername,
    audioSlug,
    from,
}: {
    authorUsername: string
    audioSlug: string
    from?: string
}): string =>
    getUrl({
        url: `${getAudioPageUrl({ authorUsername, audioSlug })}/edit`,
        params: from ? { from } : {},
    })

/**
 * The review screen of one upload. Its file lives in the flow provider above the router, so this
 * must be a soft navigation — a hard one loses it. A batch never comes here; it goes to the profile.
 */
export const getAudioUploadPageUrl = ({
    authorUsername,
    fileId,
}: {
    authorUsername: string
    fileId?: string
}): string =>
    getUrl({
        url: `/${authorUsername}/upload`,
        params: fileId ? { fileId } : {},
    })
